/**
 * <product-recommendations> özel elementi.
 * Ürün sayfasındaki "Tamamlayıcı Ürünler" ve "Bağlantılı Ürünler" bölümlerini besler.
 * Sayfa ilk yüklendiğinde bu elementin içi boştur (Liquid'deki
 * "recommendations.performed" değeri sadece Shopify'ın öneri motoru
 * section'ı ayrıca sorguladığında true olur). Bu script:
 *  1. Element ekrana yaklaşınca (IntersectionObserver, performans için)
 *     data-url'deki adrese (Shopify'ın /recommendations/products
 *     endpoint'i) fetch atar,
 *  2. Dönen HTML'in içinden, sayfadaki KAÇINCI <product-recommendations>
 *     ise (0., 1., ...) dönen belgede de AYNI SIRADAKİ elementi bulup
 *     onun dolu içeriğini alır,
 *  3. Sayfadaki elementin içine yerleştirir.
 * Öneri bulunamazsa element kendini DOM'dan kaldırır.
 *
 * NOT: Önceki sürüm eşleştirmeyi "data-intent" özniteliğiyle yapıyordu, ama
 * bu güvenilmez çıktı — iki blok da (Tamamlayıcı/Bağlantılı) birbirinin
 * içeriğini gösterebiliyordu. Sıra (index) tabanlı eşleştirme, hem canlı
 * sayfada hem de fetch edilen HTML'de bloklar HER ZAMAN aynı sırada
 * render olduğu için (section dosyasındaki yazılış sırası) çok daha
 * güvenilir — öznitelik okuma/eşleştirmeyle ilgili hiçbir belirsizliğe
 * bağımlı değil.
 */
(function () {
  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;

      // Bu elementin, sayfadaki TÜM <product-recommendations> elementleri
      // arasında kaçıncı sırada olduğunu belirle.
      var allOnPage = document.querySelectorAll('product-recommendations');
      this._recIndex = Array.prototype.indexOf.call(allOnPage, this);

      var el = this;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(el);
            el.fetchRecommendations(url);
          });
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      observer.observe(this);
    }

    fetchRecommendations(url) {
      var self = this;

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var allInDoc = doc.querySelectorAll('product-recommendations');
          var newEl = allInDoc[self._recIndex] || allInDoc[0];

          if (newEl && newEl.innerHTML.trim().length > 0) {
            self.innerHTML = newEl.innerHTML;
          } else {
            self.remove();
          }
        })
        .catch(function () {
          self.remove();
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
